import React, { Fragment } from 'react';
import image_404 from '../../../assets/images/image_404.png';
import ErrorUi from '../../../components/user-interfaces/error/error.ui';

/**
 * Composant de la page d'erreur 404
 * @constructor
 */
export default function ErrorPage() {
    return (
        <Fragment>
            <ErrorUi img={image_404} title="404" msg="Aïe... une erreur est survenue !" />
        </Fragment>
    );
}
